import { FormElement } from './form-element.model';

export class FormGroup {
  public constructor() {
    this.Id = 0;
    this.Name = '';
    this.Title = '';
    this.Order = 0;
    this.GroupElements = new Array<any>();
  }

  public Id: number;
  public Name: string;
  public Title: string;
  public Order: number;
  public GroupElements: Array<any>;
}
